// extracted by mini-css-extract-plugin
export var loadingSpinner = "_16-0";
export var spinnerContainer = "_16-1";